import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  searchTitle: {
    marginTop: 16,
  },
  resultsGrid : {
    paddingBottom: 16
  }
}));

export default styles;